import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import authReducer from './auth_reducer';
import listingReducer from './listing_reducer';
import inspectionReducer from './inspection_reducer';
import priceListReducer from './pricelist_reducer';
import reportReducer from './report_reducer';
import reportTemplateReducer from './report_template_reducer';
import reportModuleReducer from './report_module_reducer';
import accountInvoiceReducer from './account_invoice_reducer';
import dashboardReducer from './dashboard_reducer';
import accountRemittanceReducer from './account_remittance_reducer';
import accountExpenseReducer from './account_expense_reducer';
import filterReducer from './filter_reducer';
import pvReducer from './property_visit_reducer';

const rootReducer = combineReducers({
    form: formReducer,
    auth: authReducer,
    list: listingReducer,
    inspection: inspectionReducer,
    priceList: priceListReducer,
    report:reportReducer,
    reportTemplate:reportTemplateReducer,
    reportModule:reportModuleReducer,
    accountInvoice:accountInvoiceReducer,
    accountRemittance:accountRemittanceReducer,
    accountExpense:accountExpenseReducer,
    dashboardStats:dashboardReducer,
    filterAttribute: filterReducer,
    pv:pvReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js